import { useEffect, useState } from "react";
import { imgSrc } from "@/lib/api";

// Shows the whole member photo (no cropping) over a blurred copy, or the logo card if missing/broken.
export const MemberPhoto = ({ src, alt, imgClass = "", logoClass, glow, testId }) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);
  if (src && !broken) {
    const url = imgSrc(src);
    return (
      <div className="absolute inset-0 overflow-hidden bg-black">
        <img src={url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-125 blur-2xl opacity-50 grayscale" />
        <img src={url} alt={alt} onError={() => setBroken(true)} className={`absolute inset-0 w-full h-full object-contain object-top ${imgClass}`} />
      </div>
    );
  }
  return (
    <div data-testid={testId} className={`absolute inset-0 ${glow}`}>
      <img src="/logo-mark.png" alt="" className={logoClass} />
    </div>
  );
};
